import { render, staticRenderFns } from "./ExtrasPage.vue?vue&type=template&id=8f3e1018&"
import script from "./ExtrasPage.vue?vue&type=script&lang=js&"
export * from "./ExtrasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports